import Localization from '~/client/src/shared/localization/LocalizationManager'
import { IResourceRecord } from '~/client/src/shared/resources/definitions/types'
import { resolveResourceValue } from '~/client/src/shared/resources/resolveResourceValue'

export const RESOURCE_QUICK_FILTER_ME_KEY = '__resource_quick_filter_me__'
export const RESOURCE_QUICK_FILTER_ME_OPTION_ID = 'me'
export const RESOURCE_QUICK_FILTER_MY_COMPANY_KEY =
  '__resource_quick_filter_my_company__'
export const RESOURCE_QUICK_FILTER_MY_COMPANY_OPTION_ID = 'myCompany'

export const isResourceQuickFilterKey = (key: string): boolean =>
  key === RESOURCE_QUICK_FILTER_ME_KEY ||
  key === RESOURCE_QUICK_FILTER_MY_COMPANY_KEY

export const getPersistableResourceFilterSelectionIds = (
  ids: string[],
): string[] =>
  ids.filter(id => {
    const colonIdx = id.indexOf(':')
    if (colonIdx === -1) {
      return true
    }

    return !isResourceQuickFilterKey(id.slice(0, colonIdx))
  })

export const retainQuickFilterSelectionIds = (
  nextIds: string[],
  currentIds: string[],
): string[] => [
  ...nextIds,
  ...currentIds.filter(id => {
    const colonIdx = id.indexOf(':')
    return colonIdx !== -1 && isResourceQuickFilterKey(id.slice(0, colonIdx))
  }),
]

export interface IQuickFilters {
  isOnlyMe: boolean
  isOnlyMyCompany: boolean
  toggleOnlyMe: () => void
  toggleOnlyMyCompany: () => void
  hasUserProperties: boolean
  hasCompanyProperties: boolean
  resetQuickFilters: () => void
}

export interface IResourceQuickFilterDefinition {
  key: string
  optionId: string
  label: string
  isAvailable: boolean
  matchesRecord: (record: IResourceRecord) => boolean
}

interface IGetResourceQuickFilterDefinitionsOptions {
  resourceTypeId: string
  userPropertyKeys: string[]
  companyPropertyKeys: string[]
  currentUserId?: string
  currentUserCompanyId?: string | null
}

const matchesAnyProperty = (
  record: IResourceRecord,
  resourceTypeId: string,
  propertyKeys: string[],
  targetValue?: string | null,
): boolean => {
  if (!targetValue || propertyKeys.length === 0) {
    return false
  }

  return propertyKeys.some(
    key =>
      resolveResourceValue({ record, resourceTypeId, key }) === targetValue,
  )
}

export function getResourceQuickFilterDefinitions({
  resourceTypeId,
  userPropertyKeys,
  companyPropertyKeys,
  currentUserId,
  currentUserCompanyId,
}: IGetResourceQuickFilterDefinitionsOptions): IResourceQuickFilterDefinition[] {
  return [
    {
      key: RESOURCE_QUICK_FILTER_ME_KEY,
      optionId: RESOURCE_QUICK_FILTER_ME_OPTION_ID,
      label: Localization.translator.me,
      isAvailable: userPropertyKeys.length > 0 && !!currentUserId,
      matchesRecord: (record: IResourceRecord) =>
        matchesAnyProperty(
          record,
          resourceTypeId,
          userPropertyKeys,
          currentUserId,
        ),
    },
    {
      key: RESOURCE_QUICK_FILTER_MY_COMPANY_KEY,
      optionId: RESOURCE_QUICK_FILTER_MY_COMPANY_OPTION_ID,
      label: Localization.translator.myCo,
      isAvailable: companyPropertyKeys.length > 0 && !!currentUserCompanyId,
      matchesRecord: (record: IResourceRecord) =>
        matchesAnyProperty(
          record,
          resourceTypeId,
          companyPropertyKeys,
          currentUserCompanyId,
        ),
    },
  ]
}
